exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.picframe {\n  padding: 10px;\n  border-style: solid;\n  border-color: #28567e;\n  border-width: 1px;\n  max-width: 60%;\n  max-height: 60%;\n  width: 60%;\n  height: 60%;\n  border-radius: 6px;\n  margin: 10px;\n}\nimg.smallerpreview {\n  max-width: 100%;\n  max-height: 100%;\n  padding: 60px;\n}\n", ""]);

// exports
